<template>
  <div class="wrap_address">
    <div>
      <h4 class="title-color">Personal Information</h4>
    </div>
    <div class="e-card-separator"></div>
    <div class="form-row">
      <div style="width: 310px" class="form-row-input">
        <ejs-dropdownlist
          float-label-type="Always"
          id="prefix"
          :dataSource="prefix"
          v-model="data.prefix"
          placeholder="Prefix"
        >
        </ejs-dropdownlist>
      </div>
      <div style="width: 310px" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="data.firstName"
          @validate="(v) => (this.isFirstNameValid = v)"
        >
          <ejs-textbox
            float-label-type="Always"
            placeholder="First Name"
            v-model="data.firstName"
          />
        </scc-input-validator>
      </div>
      <div style="width: 310px" class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="Middle Name"
          v-model="data.middleName"
        />
      </div>
      <div style="width: 310px" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="data.lastName"
          @validate="(v) => (this.isLastNameValid = v)"
        >
          <ejs-textbox
            float-label-type="Always"
            placeholder="Last Name"
            v-model="data.lastName"
          />
        </scc-input-validator>
      </div>
    </div>
    <div>
      <h4 class="title-color">Address Information</h4>
    </div>
    <div class="e-card-separator"></div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="data.address"
          @validate="(v) => (this.isAddressValid = v)"
        >
          <ejs-autocomplete
            :dataSource="addressAutocompleteData"
            placeholder="Address Line1"
            :fields="addressAutocompleteFields"
            ref="addressAutocomplete"
            :minLength="addressAutocompleteMinLength"
            :filtering="onAddressAutocompleteFiltering"
            @change="onAddressSelection"
            float-label-type="Always"
            v-model="data.address"
          ></ejs-autocomplete>
        </scc-input-validator>
      </div>
      <div style="width: 650px" class="form-row-input">
        <ejs-textbox
          name="default"
          float-label-type="Always"
          :multiline="false"
          placeholder="Address Line2"
          v-model="data.addressLine2"
        >
        </ejs-textbox>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="data.cityName"
          @validate="(v) => (this.isCityNameValid = v)"
        >
          <ejs-textbox
            name="default"
            float-label-type="Always"
            placeholder="City"
            v-model="data.cityName"
          >
          </ejs-textbox>
        </scc-input-validator>
      </div>
      <div style="width: 650px" class="form-row-input">
        <ejs-dropdownlist
          id="province"
          ref="province"
          placeholder="Province/State"
          sortOrder="Ascending"
          :allowFiltering="allowFiltering"
          float-label-type="Always"
          :filtering="filtering"
          :dataSource="province"
          v-model="data.provinceName"
          :fields="provinceFields"
        >
        </ejs-dropdownlist>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="data.postalCode"
          @validate="(v) => (this.isPostalCodeValid = v)"
        >
          <ejs-textbox
            name="default"
            float-label-type="Always"
            placeholder="Postal/Zip Code"
            v-model="data.postalCode"
            :maxlength="10"
          >
          </ejs-textbox>
        </scc-input-validator>
      </div>
      <div style="width: 650px" class="form-row-input">
        <ejs-dropdownlist
          float-label-type="Always"
          id="country"
          ref="country"
          :dataSource="countries"
          placeholder="Country"
          :fields="countryFields"
          :index="countryIndex"
          v-model="data.countryName"
        ></ejs-dropdownlist>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import {
  DropDownListPlugin,
  AutoCompletePlugin,
} from '@syncfusion/ej2-vue-dropdowns';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { Query } from '@syncfusion/ej2-data';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';

import {
  GET_PROVINCES,
  USER_PROFILES,
  GET_MELISSA_ADDRESSES,
  GET_USER_PROFILES_BY_ID,
} from '../store';

Vue.use(DropDownListPlugin);
Vue.use(TextBoxPlugin);
Vue.use(AutoCompletePlugin);

export default {
  name: 'UserAddressInfo',
  props: {
    userProfilesData: Object,
    userProfileId: String,
  },
  components: {
    SccInputValidator,
  },
  mounted() {
    this.getAddresses();
    this.province = this.$store.getters.provinces;
    if (this.province === null) {
      this.getProvinces();
    }
    // if (this.userProfilesData !== null) this.userProfileData = this.userProfilesData;
    if (this.$store.getters.loggedUser !== null) this.getUserProfilesById();
  },
  data() {
    return {
      prefix: ['Dr.', 'Mr.', 'Mrs.', 'Ms.', 'Miss.'],
      username: null,
      // provinceCode: '',
      id: null,
      data: {
        userId: null,
        userFullName: null,
        email: null,
        prefix: null,
        firstName: null,
        middleName: null,
        lastName: null,
        phoneNumber: null,
        address: null,
        addressLine2: '',
        cityName: null,
        postalCode: null,
        provinceName: null,
        countryName: null,
      },
      countries: [
        { id: 'CA', countryName: 'Canada' },
        { id: 'US', countryName: 'United States' },
      ],
      countryIndex: 0,
      addressAutocompleteData: [],
      addressAutocompleteMinLength: 3,
      addressAutocompleteFields: { value: 'Address.Address' },
      province: [],
      provinceFields: {
        text: 'provinceName',
        value: 'provinceName',
        groupBy: 'countryName',
      },
      countryFields: { text: 'countryName', value: 'countryName' },
      allowFiltering: false,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isFirstNameValid: false,
      isLastNameValid: false,
      isAddressValid: false,
      isCityNameValid: false,
      isPostalCodeValid: false,
      melissaAddress1: '',
      // melissaLocality: 'Edmonton',
      // melissaAdministrativearea: 'Alberta',
      melissaCountry: 'CA',
      userProfileData: null,
      melissaCountryName: 'Canada',
    };
  },
  methods: {
    async getProvinces() {
      try {
        await this.$store.dispatch(GET_PROVINCES);
        this.province = this.$store.getters.provinces;
        // this.province = [{ provinceName: '', countryName: '' }]
        //   .concat(this.$store.getters.provinces.map((cv) =>
        // ({ provinceName: cv.provinceName, countryName: cv.countryName })));
      } catch (err) {
        console.error(err);
      }
    },
    async getAddresses() {
      try {
        const { melissaAddress1, melissaCountry } = this;
        await this.$store.dispatch(GET_MELISSA_ADDRESSES, {
          melissaAddress1,
          melissaCountry,
        });
        this.addressAutocompleteData = this.$store.getters.melissaAddresses;
      } catch (err) {
        console.error(err);
      }
    },
    async getUserProfilesById() {
      try {
        const userId = this.userProfileId; // this.$store.getters.loggedUser.id;
        await this.$store.dispatch(GET_USER_PROFILES_BY_ID, { userId });
        this.data = { ...this.data, ...this.$store.getters.userProfilesbyID };
        if (this.$store.getters.userProfilesbyID !== null) {
          // this.provinceCode = this.$store.getters.userProfilesbyID.provinceName;
          this.id = this.$store.getters.userProfilesbyID.id;
        } else {
          // this.provinceCode = '';
          this.id = null;
        }
      } catch (err) {
        console.error(err);
      }
    },
    onCancelButtonClick() {
      this.$router.push('/');
    },
    filtering(e) {
      const searchData = this.province;
      let query = new Query();
      // frame the query based on search string with filter type.
      query = e.text !== ''
        ? query.where('provinceName', 'startswith', e.text, true)
        : query;
      // pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    validateUserInfo() {
      this.data.firstName = this.data.firstName === null ? '' : this.data.firstName;
      this.data.lastName = this.data.lastName === null ? '' : this.data.lastName;
      this.data.address = this.data.address === null ? '' : this.data.address;
      this.data.cityName = this.data.cityName === null ? '' : this.data.cityName;
      this.data.postalCode = this.data.postalCode === null ? '' : this.data.postalCode;
    },
    async userProfile(contactNumber) {
      try {
        this.data.provinceName = this.$refs.province.ej2Instances.value;
        this.data.userFullName = `${this.data.firstName} ${this.data.lastName}`;
        this.data.phoneNumber = contactNumber;
        this.data.userId = this.userProfileId; // this.$store.getters.confirmedUser.userId;
        this.username = this.userProfilesData.userName;
        this.data.email = this.userProfilesData.userName;
        if (this.id !== null) {
          const data = Object.assign(this.data, { id: this.id });
          await this.$store.dispatch(USER_PROFILES, data);
        } else {
          await this.$store.dispatch(USER_PROFILES, this.data);
        }
      } catch (err) {
        console.error(err);
      }
    },
    onAddressAutocompleteFiltering(e) {
      e.preventDefaultAction = true;
      if (
        e.text.length >= this.$refs.addressAutocomplete.ej2Instances.minLength
      ) {
        this.$refs.addressAutocomplete.ej2Instances.showSpinner();
        this.melissaAddress1 = e.text;
        this.melissaCountry = this.$refs.country.ej2Instances.value;
        const { melissaAddress1, melissaCountry } = this;
        this.$store
          .dispatch(GET_MELISSA_ADDRESSES, {
            melissaAddress1,
            melissaCountry,
          })
          .then(() => {
            e.updateData(this.$store.getters.melissaAddresses);
          });
      }
    },
    onAddressSelection(e) {
      if (e?.value) {
        // eslint-disable-next-line prefer-destructuring
        this.$refs.addressAutocomplete.$el.value = e.value.split(',')[0];
        const { itemData } = e;
        if (itemData.Address) {
          this.data.address = itemData.Address.Address || '';
          if (this.data.address === this.$refs.addressAutocomplete.$el.value) {
            return;
          }
          this.data.cityName = itemData.Address.SubAdministrativeArea
            || itemData.Address.Locality
            || '';
          this.data.provinceName = itemData.Address.AdministrativeArea || '';
          this.data.countryName = itemData.Address.ISO3166_2 || '';
          if (itemData.Address.ISO3166_2 === 'CA') {
            this.data.countryName = this.melissaCountryName;
          } else if (itemData.Address.ISO3166_2 === 'US') {
            this.data.countryName = 'United States';
          } else {
            this.data.countryName = this.melissaCountryName;
          }
          this.data.postalCode = itemData.Address.PostalCode || '';
          const checkAddress2 = (
            this.data.cityName
            + this.data.provinceName
            + this.data.postalCode
          ).replace(/ /g, '');
          const address2 = itemData.Address.Address2?.replace(/ /g, '');
          if (address2?.toLowerCase() === checkAddress2?.toLowerCase()) this.data.addressLine2 = '';
          else this.data.addressLine2 = itemData.Address.Address2 || '';
          if (this.data.provinceName !== '') {
            this.province.every((r) => {
              if (r.provinceCode === this.data.provinceName) {
                this.data.provinceName = r.provinceName;
                return true;
              }
              return true;
            });
          }
        } else {
          this.data.address = itemData['Address.Address'];
        }
      }
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../../../assets/styles/eservices-base.css";

#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}
</style>
